const BADGES_SELECTOR = '.\\#product-title-badges';
const GALLERY_TARGET_SELECTOR = '[data-product-badges-overlay-target]';
const OVERLAY_ACTIVE_ATTRIBUTE = 'data-product-badges-overlay-active';
const OVERLAY_CLASS = '@overlay';

const productProvider = document.querySelector('product-variant-provider[product-page]');
const badges = productProvider?.querySelector(BADGES_SELECTOR);
const galleryManager = productProvider?.querySelector('product-gallery-manager');
const anchor = badges ? document.createComment('product-title-badges') : null;

let overlayEnabled = false;

if (badges) {
    badges.before(anchor);
}

function hasBadgeContent() {
    return badges && (badges.children.length > 0 || badges.textContent.trim() !== '');
}

function moveToOverlay() {
    if (!hasBadgeContent()) return false;

    const target = galleryManager?.querySelector(GALLERY_TARGET_SELECTOR);
    if (!target) return false;

    target.setAttribute(OVERLAY_ACTIVE_ATTRIBUTE, '');
    badges.classList.add(OVERLAY_CLASS);
    if (badges.parentNode !== target) {
        target.append(badges);
    }
    return true;
}

function restoreBadges() {
    if (!badges || !anchor?.parentNode) return false;

    galleryManager?.querySelectorAll(GALLERY_TARGET_SELECTOR).forEach((target) => {
        target.removeAttribute(OVERLAY_ACTIVE_ATTRIBUTE);
    });
    badges.classList.remove(OVERLAY_CLASS);
    if (badges.previousSibling !== anchor) {
        anchor.after(badges);
    }
    return true;
}

function setOverlay(enabled) {
    overlayEnabled = enabled === true;
    return overlayEnabled ? moveToOverlay() : restoreBadges();
}

galleryManager?.addEventListener('update', () => {
    if (overlayEnabled) {
        moveToOverlay();
    }
});

window.MSGProductBadges = { setOverlay };
